(function() {
    'use strict';

    angular
        .module('atheer.sdk')
        .controller('SdkWebHookEventSettingsController', SdkWebHookEventSettingsController);

    /* @ngInject */
    function SdkWebHookEventSettingsController($mdDialog, $q, AirForm, filters) {
        var vm = this;

        var familiesById = {};
        var airFormsById = {};

        // Edit a copy so Cancel leaves the webhook untouched. Filters this dialog does not show
        // (e.g. airform_ids set through the API) are kept as they are.
        vm.filters = angular.copy(filters) || {};
        vm.filters.airform_family_ids = copyList(vm.filters.airform_family_ids);
        vm.filters.step_ids = copyList(vm.filters.step_ids);

        vm.selectedFamilies = [];
        vm.selectedSteps = [];
        vm.availableSteps = [];
        vm.familySearchText = '';
        vm.stepSearchText = '';

        vm.searchFamilies = function(text) {
            var params = { size: 20, page: 0 };
            if (text) {
                params.query = 'name=re="' + escapeQueryValue(text) + '"';
            }
            return AirForm.getFamilies(params).$promise.then(function(families) {
                return families.filter(function(family) {
                    return vm.filters.airform_family_ids.indexOf(family.id) === -1;
                });
            });
        };

        function escapeQueryValue(value) {
            return String(value)
                .replace(/\\/g, '\\\\')
                .replace(/"/g, '\\"');
        }

        vm.onFamilyAdded = function(family) {
            familiesById[family.id] = family;
            vm.filters.airform_family_ids.push(family.id);
            refreshAvailableSteps();
        };

        vm.onFamilyRemoved = function(family) {
            remove(vm.filters.airform_family_ids, family.id);
            refreshAvailableSteps();
        };

        vm.searchSteps = function(text) {
            var query = (text || '').toLowerCase();
            return vm.availableSteps.filter(function(step) {
                return vm.filters.step_ids.indexOf(step.id) === -1
                    && (!query || step.label.toLowerCase().indexOf(query) > -1);
            });
        };

        vm.onStepAdded = function(step) {
            vm.filters.step_ids.push(step.id);
        };

        vm.onStepRemoved = function(step) {
            remove(vm.filters.step_ids, step.id);
        };

        vm.apply = function() {
            $mdDialog.hide(isEmpty(vm.filters) ? null : vm.filters);
        };

        vm.cancel = function() {
            $mdDialog.cancel();
        };

        // Saved filters only hold family ids, so load the families to show their names.
        function loadSavedFamilies() {
            if (!vm.filters.airform_family_ids.length) {
                return $q.when();
            }
            return AirForm.getFamilies({ size: 1000, page: 0 }).$promise.then(function(families) {
                angular.forEach(families, function(family) {
                    familiesById[family.id] = family;
                });
            });
        }

        function loadAirForm(id) {
            if (airFormsById[id]) {
                return $q.when(airFormsById[id]);
            }
            return AirForm.get({ id: id }).$promise.then(function(airForm) {
                airFormsById[id] = airForm;
                return airForm;
            }, function() {
                // One AiR Form failing to load must not hide the steps of the others.
                return null;
            });
        }

        // The latest version of a family stands in for the family when listing its steps.
        function loadLatestAirFormOfFamily(familyId) {
            return AirForm.getFamilyVersions({ familyId: familyId }).$promise.then(function(versions) {
                var latest = null;
                angular.forEach(versions, function(version) {
                    if (!latest || version.version > latest.version) {
                        latest = version;
                    }
                });
                return latest ? loadAirForm(latest.id) : null;
            }, function() {
                return null;
            });
        }

        function refreshSelectedFamilies() {
            vm.selectedFamilies = vm.filters.airform_family_ids.map(function(id) {
                return familiesById[id] || { id: id, name: id };
            });
        }

        function refreshAvailableSteps() {
            $q.all(vm.filters.airform_family_ids.map(loadLatestAirFormOfFamily)).then(function(airForms) {
                var stepsById = {};
                angular.forEach(airForms, function(airForm) {
                    if (airForm) {
                        collectSteps(airForm, stepsById);
                    }
                });
                vm.availableSteps = Object.keys(stepsById).map(function(id) {
                    return stepsById[id];
                });
                vm.selectedSteps = vm.filters.step_ids.map(function(id) {
                    return stepsById[id] || { id: id, label: id };
                });
            });
        }

        // Steps sit in lanes > sections > steps; a branch step holds more steps in its paths.
        function collectSteps(airForm, stepsById) {
            angular.forEach(airForm.lanes, function(lane) {
                angular.forEach(lane.sections, function(section) {
                    angular.forEach(section.steps, function(step) {
                        if (step.moleculeType === 'BRANCH') {
                            angular.forEach(step.paths, function(path) {
                                angular.forEach(path.steps, function(pathStep) {
                                    addStep(airForm, pathStep, stepsById);
                                });
                            });
                        } else {
                            addStep(airForm, step, stepsById);
                        }
                    });
                });
            });
        }

        function addStep(airForm, step, stepsById) {
            if (!step || !step.id || stepsById[step.id]) {
                return;
            }
            stepsById[step.id] = {
                id: step.id,
                label: (stepTitle(step) || step.id) + ' (' + airForm.name + ')'
            };
        }

        function stepTitle(step) {
            var title = null;
            angular.forEach(step.metadata, function(data) {
                if (data.level === 'HEADER') {
                    angular.forEach(data.values, function(value) {
                        if (value.name === 'title' && !title) {
                            title = value.value;
                        }
                    });
                }
            });
            return title;
        }

        function copyList(list) {
            return angular.isArray(list) ? list.slice() : [];
        }

        function remove(list, value) {
            var index = list.indexOf(value);
            if (index > -1) {
                list.splice(index, 1);
            }
        }

        function isEmpty(filters) {
            return Object.keys(filters).every(function(key) {
                return !filters[key] || !filters[key].length;
            });
        }

        loadSavedFamilies().then(function() {
            refreshSelectedFamilies();
            refreshAvailableSteps();
        });
    }
})();
